module.exports = __webpack_public_path__ + "img/logo.ea8fe322.svg";